<template>
  <div
    class="br-logo-carousel">
    <div
      v-for="(entry, index) in entries"
      :key="index"
      class="br-logo-carousel__item">
      <div class="br-logo-carousel__block">
        <div class="br-logo-carousel__panel">
          <div class="br-logo-carousel__logo">
            <img :src="entry.logo">
          </div>
          <a
            :href="entry.link"
            target="_blank"
            class="button button--icon"><i class="icon icon-link"/></a>
        </div>
        <div class="br-logo-carousel__panel">
          <p class="u-line-clamp-3">
            {{ entry.description }}
          </p>
        </div>
        <div class="br-logo-carousel__pattern">
          <img
            src="/img/patterns/dot-pattern-dark.svg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider'

export default {
  data: () => ({
    entries: [{
      logo: '/img/logo/professionals/helmbriscoe.jpg',
      description: 'We streamline your meeting & event planning process',
      link: 'http://helmsbriscoe.com/'
    }, {
      logo: '/img/logo/professionals/mci.jpg',
      description: 'Our mission is to build a profoundly human organization',
      link: 'http://mci-group.com/'
    }, {
      logo: '/img/logo/professionals/wells-fargo.jpg',
      description: 'Helping our customers & communities succeed financially',
      link: 'http://wellsfargo.com/'
    }, {
      logo: '/img/logo/professionals/pnc.jpg',
      description: 'Providing employees with the opportunities to make an impact',
      link: 'http://pnc.com/'
    }, {
      logo: '/img/logo/professionals/maritz.jpg',
      description: 'Helping our clients achieve their full potential through understanding',
      link: 'http://maritz.com/'
    }, {
      logo: '/img/logo/professionals/merrill.jpg',
      description: 'At Merrill our goal is to act in ways that help us understand our clients',
      link: 'http://ml.com/'
    }, {
      logo: '/img/logo/professionals/alix-partners.jpg',
      description: 'We aspire to become the leading professional services firm ',
      link: 'http://alixpartners.com/'
    }, {
      logo: '/img/logo/professionals/new-york-life.jpg',
      description: 'We are in the business of helping people achieve their goals',
      link: 'https://www.newyorklife.com/'
    }, {
      logo: '/img/logo/professionals/rsm.jpg',
      description: 'Deliver the power of teamwork - work together effectively',
      link: 'http://rsmus.com/'
    }, {
      logo: '/img/logo/professionals/american-express.jpg',
      description: 'Bringing to life the values of good corporate citizenship',
      link: 'https://www.americanexpress.com/'
    }, {
      logo: '/img/logo/professionals/deloitte.jpg',
      description: 'There\'s No Limit To What Your Company Can Accomplish',
      link: 'http://deloitte.com/'
    }, {
      logo: '/img/logo/professionals/kenes-group.jpg',
      description: 'World\'s leading facilitator of meetings for global exchange',
      link: 'http://kenes.com/'
    }, {
      logo: '/img/logo/professionals/morgan-stanley.jpg',
      description: 'Dedicated to local & global communities since 1935',
      link: 'http://morganstanley.com/'
    }, {
      logo: '/img/logo/professionals/ey.jpg',
      description: 'Building a better working world for our clients and employees',
      link: 'http://ey.com/'
    }, {
      logo: '/img/logo/professionals/hilton.jpg',
      description: 'Fill the earth with the light & warmth of hospitality',
      link: 'http://hilton.com/'
    }, {
      logo: '/img/logo/professionals/bank-of-america.jpg',
      description: 'Offering lending & investment products that serve individuals & families',
      link: 'http://baml.com/'
    }, {
      logo: '/img/logo/professionals/insperity.jpg',
      description: 'Helping our businesses succeed so communities can prosper',
      link: 'http://insperity.com/'
    }, {
      logo: '/img/logo/professionals/experient.jpg',
      description: 'Partnering with great clients to deliver exceptional experiences',
      link: 'https://esn.experientselect.com/'
    }, {
      logo: '/img/logo/professionals/cbiz.jpg',
      description: 'Providing exceptional advice and solutions that help our clients',
      link: 'http://cbiz.com/'
    }, {
      logo: '/img/logo/professionals/conway-mackenzie.jpg',
      description: 'We help ensure today\'s performance correlates to tomorrow\'s returns',
      link: 'http://conwaymackenzie.com/'
    }, {
      logo: '/img/logo/professionals/jpmorgan.jpg',
      description: 'Dedicated to being the best financial services company in the world',
      link: 'http://jpmorgan.com/'
    }, {
      logo: '/img/logo/professionals/prudential.jpg',
      description: 'To help our customers achieve financial prosperity and peace of mind',
      link: 'http://prudential.com/'
    }, {
      logo: '/img/logo/professionals/bernstein.jpg',
      description: 'Dedicated to the mission of creating better futures for our clients',
      link: 'http://bernstein.com/'
    }, {
      logo: '/img/logo/professionals/ubs.jpg',
      description: 'Our mission is simple: to guide you towards a brighter future for your investments',
      link: 'http://ubs.com/'
    }, {
      logo: '/img/logo/professionals/usbank.jpg',
      description: 'We work to meet our customers\' business and personal banking needs',
      link: 'http://usbank.com/'
    }, {
      logo: '/img/logo/professionals/bcd.jpg',
      description: 'Experiences & solutions where people, passion and purpose come together',
      link: 'http://bcdme.com/'
    }, {
      logo: '/img/logo/professionals/cvent.jpg',
      description: 'Our mission is to create technology that powers human connection',
      link: 'http://cvent.com/'
    }, {
      logo: '/img/logo/professionals/ihg.jpg',
      description: 'Our purpose is to create Great Hotels Guests Love',
      link: 'http://ihg.com/'
    }, {
      logo: '/img/logo/professionals/lsq.jpg',
      description: 'We are the leader in supplying working capital solutions.',
      link: 'http://lsq.com/'
    }, {
      logo: '/img/logo/professionals/allstate.jpg',
      description: 'We are the Good Hands: We help people realize their hopes and dreams',
      link: 'http://allstate.com/'
    }, {
      logo: '/img/logo/professionals/kpmg.jpg',
      description: 'Turning knowledge and understanding of information into value',
      link: 'http://kpmg.com/'
    }, {
      logo: '/img/logo/professionals/lockton.jpg',
      description: 'A worldwide service leader in insurance brokerage & risk management',
      link: 'http://lockton.com/'
    }, {
      logo: '/img/logo/professionals/pwc.jpg',
      description: 'Our purpose is to build trust in society and solve important problems',
      link: 'http://pwc.com/'
    }, {
      logo: '/img/logo/professionals/trinet.jpg',
      description: 'Powering the success of our partners through extraordinary human resources',
      link: 'http://trinet.com/'
    }, {
      logo: '/img/logo/professionals/aon.jpg',
      description: 'To be the most creative and thoughtful investment consultants in the industry',
      link: 'http://aon.com/'
    }, {
      logo: '/img/logo/professionals/hrg.jpg',
      description: 'Provide our clients with the highest quality home improvement solutions ',
      link: 'http://hrgworldwide.com/'
    }, {
      logo: '/img/logo/professionals/interpid.jpg',
      description: 'You were unstoppable in your quest to build your business. We get it!',
      link: 'http://intrepidib.com/'
    }, {
      logo: '/img/logo/professionals/keybank.jpg',
      description: 'We empower our clients, communities and employees to thrive',
      link: 'http://keybank.com/'
    }, {
      logo: '/img/logo/professionals/kl-gates.jpg',
      description: 'We strive to cultivate an environment that celebrates talented legal professionals',
      link: 'http://klgates.com/'
    }, {
      logo: '/img/logo/professionals/marriott.jpg',
      description: 'Enhancing the lives of our customers by enabling unsurpassed experiences',
      link: 'http://marriott.com/'
    }, {
      logo: '/img/logo/professionals/citi.jpg',
      description: 'Providing financial services that enable growth and economic progress',
      link: 'http://citi.com/'
    }, {
      logo: '/img/logo/professionals/liberty-mutual.jpg',
      description: 'Helping people live safer, more secure lives',
      link: 'http://libertymutual.com/'
    }, {
      logo: '/img/logo/professionals/prestige.jpg',
      description: 'Committed to providing best-in-class event service & value to our clients',
      link: 'http://meetprestige.com/'
    }, {
      logo: '/img/logo/professionals/siemens.jpg',
      description: 'Achieving high performance & excellent results from ambitious targets',
      link: 'http://siemens.com/'
    }, {
      logo: '/img/logo/professionals/brg.jpg',
      description: 'We are a global consulting firm that helps leading organization finance tomorrow ',
      link: 'http://thinkbrg.com/'
    }, {
      logo: '/img/logo/professionals/adp.jpg',
      description: 'A trusted HR, payroll & benefits partner to employers around the world.',
      link: 'http://adp.com/'
    }, {
      logo: '/img/logo/professionals/gallagher.jpg',
      description: 'Provide superior, cost-effective risk management products',
      link: 'http://ajg.com/'
    }, {
      logo: '/img/logo/professionals/dla-piper.jpg',
      description: 'We strive to be the leading global business law firm by delivering quality to our clients',
      link: 'http://dlapiper.com/'
    }, {
      logo: '/img/logo/professionals/farmers-insurance.jpg',
      description: 'We provide first-rate services to the customers we\'re privileged to serve.',
      link: 'http://farmersagent.com/'
    }, {
      logo: '/img/logo/professionals/focal-point.jpg',
      description: 'Impactful investment banking for entrepreneurs & capital providers',
      link: 'http://focalpointllc.com/'
    }, {
      logo: '/img/logo/professionals/getzler-henrich.jpg',
      description: 'We help companies identify & work toward the best solutions.',
      link: 'http://getzlerhenrich.com/'
    }, {
      logo: '/img/logo/professionals/houlihan-lokey.jpg',
      description: 'We help our clients achieve superior outcomes by providing thoughtful advice',
      link: 'http://hl.com/'
    }, {
      logo: '/img/logo/professionals/ita-group.jpg',
      description: 'We create and manage events, incentives & recognition programs',
      link: 'http://itagroup.com/'
    }, {
      logo: '/img/logo/professionals/sap.jpg',
      description: 'We help the world run better and improve people\'s lives',
      link: 'http://sap.com/'
    }]
  }),
  mounted () {
    tns({
      container: '.br-logo-carousel',
      items: 4,
      gutter: 50,
      controls: false,
      controlsContainer: false,
      nextButton: false,
      prevButton: false,
      navContainer: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayButton: false,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      loop: true,
      speed: 300,
      mouseDrag: false,
      responsive: {
        0: {
          gutter: 10,
          items: 2
        },
        1024: {
          gutter: 50,
          items: 3
        },
        1200: {
          gutter: 50,
          items: 4
        }
      }
    })
  }
}
</script>
